import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AREAS } from "@/lib/site";
import { AreaMap } from "@/components/home/AreaMap";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const Areas = () => (
  <section data-testid="areas-section" aria-labelledby="areas-heading" className="section bg-white">
    <div className="container-site grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
      <div>
        <SectionHeading
          id="areas"
          title="Areas We Cover" accent="Cover"
          sub="Based in Molesey, we work across Kingston, Elmbridge and the surrounding parts of Surrey and South West London."
        />
        <ul className="mt-10 grid gap-x-8 gap-y-1 sm:grid-cols-2">
          {AREAS.map((a, i) => (
            <Reveal as="li" key={a.id} delay={i * 60}>
              <Link
                to={a.to}
                data-testid={`area-link-${a.id}`}
                className="group flex items-center justify-between gap-3 border-b border-line py-3 text-base font-medium text-navy transition-colors duration-200 hover:text-brand"
              >
                Builders in {a.name}
                <ArrowRight size={18} aria-hidden="true" className="text-brand transition-transform duration-200 ease-out group-hover:translate-x-1" />
              </Link>
            </Reveal>
          ))}
        </ul>
        <Reveal className="mt-8">
          <Link to="/areas" data-testid="areas-all-link" className="inline-flex items-center gap-2 text-[15px] font-semibold text-brand transition-colors hover:text-brand-dark">
            See every area we cover in Surrey &amp; South West London
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </Reveal>
      </div>
      <Reveal delay={120}>
        <AreaMap />
      </Reveal>
    </div>
  </section>
);
